import { ScrollView } from "../ScrollView.js";
import { IScrollViewWheel } from "./IScrollViewWheel.js";
import { ScrollViewWheel } from "./ScrollViewWheel.js";

export class ScrollViewWheelCtrlZoom implements IScrollViewWheel {
    public apply(view: ScrollView, deltaY: number, event: WheelEvent): void {
        if(event.ctrlKey){
            ScrollViewWheel.Zoom.apply(view, deltaY, event);
        } else {
            ScrollViewWheel.Scroll.apply(view, deltaY, event);
        }
    }
}